import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import * as thunk from './thunk';

export const initialState = {
    dataList: [],
    logList: [],
    alarmLogList: [],
    pole: {},
    error: {},
    loading: true
};

const PoleSlice = createSlice({
    name: 'Poles',
    initialState,
    reducers: {},
    extraReducers: builder => {
        // <--------------------------- getAll --------------------------->
        builder.addCase(thunk.getAll.fulfilled, (state, action) => {
            state.dataList = action.payload;
            state.loading = true;
        });
        builder.addCase(thunk.getAll.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- create --------------------------->
        builder.addCase(thunk.create.fulfilled, (state, action) => {
            state.dataList.unshift(action.payload);
        });
        builder.addCase(thunk.create.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- update --------------------------->
        builder.addCase(thunk.update.fulfilled, (state, action) => {
            const data = action.payload;
            const id = data.id;
            if (_.isEmpty(id)) {
                return;
            }

            const dataList = (state.dataList || []).filter(x => x.id !== id);
            dataList.unshift(data);
            state.dataList = dataList;
        });
        builder.addCase(thunk.update.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- remove --------------------------->
        builder.addCase(thunk.remove.fulfilled, (state, action) => {
            state.dataList = state.dataList.filter(x => x.id !== action.payload);
        });
        builder.addCase(thunk.remove.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getById --------------------------->
        builder.addCase(thunk.getById.fulfilled, (state, action) => {
            state.pole = _.cloneDeep(action.payload);
            const data = action.payload;
            const id = data.id;
            if (_.isEmpty(id)) {
                return;
            }

            const dataList = (state.dataList || []).filter(x => x.id !== id);
            dataList.unshift(data);
            state.dataList = dataList;
        });
        builder.addCase(thunk.getById.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getLogs --------------------------->
        builder.addCase(thunk.getLogs.fulfilled, (state, action) => {
            state.logList = action.payload;
        });
        builder.addCase(thunk.getLogs.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getAlarmLogs --------------------------->
        builder.addCase(thunk.getAlarmLogs.fulfilled, (state, action) => {
            state.alarmLogList = action.payload;
        });
        builder.addCase(thunk.getAlarmLogs.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });
    }
});

export default PoleSlice.reducer;
